import { FC } from 'react';
import { InputToggle } from '../InputToggle/InputToggle';
import { InputProps } from '../../types';
import { CustomImageInput } from './CustomImageInput';
import { Container } from './ImageInput.styles';

export const ImageInput: FC<InputProps & { isPunchup?: boolean }> = ({ label, name, isPunchup = false }) => (
	<Container>
		<InputToggle htmlFor={name} name={`${name}Enabled`} label={label} isPunchup={isPunchup} />
		<CustomImageInput id={name} name={name} maxPicturesAllowed={1} isPunchup={isPunchup} />
	</Container>
);
